import React, { Component } from 'react'
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import classnames from "classnames";
import { isEmpty, get } from 'lodash'
import tracker from "./../tracker";

import { setValue, getValue, clearValue } from './../utils/keyStorage';
import { namespace } from './../config';

import Input from './shared/Input';
import Loader from './shared/Loader'
import Button from './shared/Button';
import Tooltip from './shared/Tooltip';
import IntroModal from './ApplicantForm/IntroModal';
import DropdownForm from './ApplicantForm/DropdownForm';

import {
  educationList,
  gpaList,
  academicExperience,
  tutoringExperience,
  majorList,
  minorList,
  countryList,
  hoursList,
  monthlyIncome,
} from './../constants/applicant_info';

import { profileUpdateStages, profileFetchIfNeeded } from '../store/profile/actions'
import baseStyles from 'custom/base.styl';
import gridStyles from './../styles/grid.styl';

const APPLICANT_FORM = 'applicant_form';
const MODAL_APPLICANT_FORM = 'modal_applicant_form';

const REQUIRED_FIELDS = [
  'education_level',
  'major',
  'minor',
  'gpa',
  'university',
  'country_university',
  'writing_experience',
  'online_tutoring_experience',
  'available_hours_per_week',
  'preferred_income',
  'first_name',
  'last_name',
];

class PageApplicantInfo extends Component {
  constructor(props) {
    super(props)

    this.onHideModal = this.onHideModal.bind(this)
    this.onChange = this.onChange.bind(this);
    this.onSelect = this.onSelect.bind(this);
    // this.onSelectSubject = this.onSelectSubject.bind(this);
    this.checkValidation = this.checkValidation.bind(this);
    this.onSubmit = this.onSubmit.bind(this);

    let data = JSON.parse(getValue(`${APPLICANT_FORM}${props.profileId}`)) || {};
    const showModal = getValue(MODAL_APPLICANT_FORM) || false;

    this.state = {
      showModal,
      errors: {},
      data: {
        first_name: data.first_name || '',
        last_name: data.last_name || '',
        education_level: data.education_level || '',
        major: data.major || '',
        minor: data.minor || '',
        gpa: data.gpa || '',
        university: data.university || '',
        country_university: data.country_university || '',
        writing_experience: data.writing_experience || '',
        online_tutoring_experience: data.online_tutoring_experience || '',
        platform_name: data.platform_name || '',
        link_to_profile: data.link_to_profile || '',
        available_hours_per_week: data.available_hours_per_week || '',
        preferred_income: data.preferred_income || '',
        // subjects: data.subjects || [],
      }
    }
  }

  componentDidMount() {
    this.props.loadProfile();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.data !== this.state.data) {
      setValue(`${APPLICANT_FORM}${this.props.profileId}`, JSON.stringify(this.state.data));
    }
    if (prevProps.profileId !== this.props.profileId) {
      const data = JSON.parse(getValue(`${APPLICANT_FORM}${this.props.profileId}`)) || {};
      if (!isEmpty(data)) {
        this.setState({ data });
      }
    }
  }

  setApplicationData(payload) {
    const { profileId } = this.props;
    const key = `${namespace}-${profileId}`;
    tracker.store.set(key, payload).then(res => console.log(res.ok)).catch(error => {
      console.error('Error set application form:', error)
    });
    return;
  }

  onHideModal() {
    setValue(MODAL_APPLICANT_FORM, true);
    this.setState({
      showModal: true,
    });
  }

  onSelect(field, value) {
    const newErrors = this.state.errors;
    delete newErrors[field];

    if (field === 'online_tutoring_experience' && value === 'No') {
      this.setState({
        data: {
          ...this.state.data,
          [field]: value,
          platform_name: '',
          link_to_profile: '',
        },
        errors: newErrors,
      });
    } else {
      this.setState({
        data: {
          ...this.state.data,
          [field]: value,
        },
        errors: newErrors,
      });
    }
  }

  // onSelectSubject(value) {
  //   const { subjects } = this.state.data;
  //   const newSubject = subjects.indexOf(value) > -1 ? subjects.filter(s => s !== value) : [...subjects, value];
  //   const newErrors = this.state.errors;
  //   if (newSubject.length >= 5) {
  //     delete newErrors.subjects;
  //   }

  //   this.setState({
  //     data: {
  //       ...this.state.data,
  //       subjects: newSubject,
  //     },
  //     errors: newErrors,
  //   });
  // }

  onChange(e) {
    const { name, value } = e.target
    const newErrors = this.state.errors;
    delete newErrors[name];

    this.setState({
      data: {
        ...this.state.data,
        [name]: value,
      },
      errors: newErrors,
    });
  }

  onSubmit() {
    const { profileUpdateStages } = this.props;
    const errors = this.checkValidation();
    const isValid = isEmpty(errors);

    if (!isValid) {
      const keys = Object.keys(errors);
      if (keys.length > 0) {
        const el = document.getElementById(keys[0]);
        return el.scrollIntoView({ behavior: "smooth" });
      }
    }

    if (isValid) {
      const { data } = this.state;
      clearValue(`${APPLICANT_FORM}${this.props.profileId}`);
      clearValue(MODAL_APPLICANT_FORM);
      this.setApplicationData(data);
      profileUpdateStages(data);
      return;
    }
  }

  checkValidation() {
    const { data } = this.state;
    let newErrors = {};
    REQUIRED_FIELDS.map(f => {
      // if (!data[f] || data[f].length <= 0 || (f === 'subjects' && data[f].length < 5)) {
      if (!data[f] || data[f].length <= 0) {
        newErrors = { ...newErrors, [f]: true }
        this.setState({
          errors: newErrors,
        });
      }
    });
    return newErrors;
  }

  render() {
    const { errors, showModal } = this.state;
    const {
      first_name,
      last_name,
      education_level,
      major,
      minor,
      gpa,
      university,
      country_university,
      writing_experience,
      online_tutoring_experience,
      platform_name,
      link_to_profile,
      available_hours_per_week,
      preferred_income,
    } = this.state.data;

    const { isFetching } = this.props;
    const showAdditionalField = online_tutoring_experience && online_tutoring_experience !== 'No';

    if (isFetching) {
      return <Loader absolute />
    }

    return [
      <div key='applicant-form-intro'>
        {!showModal &&
          <IntroModal onHideModal={this.onHideModal} />
        }
      </div>,

      <div className={baseStyles.content} key='applicant-form-header'>
        <div className={baseStyles.header}><h1 className={baseStyles.title}>Application form</h1></div>
        <p className={classnames(baseStyles.title_extra_small, baseStyles.centered, baseStyles.mb_20, baseStyles.text_light)}>
          Note that all your personal information mentioned in this application form is kept confidential.
        </p>
        <p className={classnames(baseStyles.title_extra_small, baseStyles.centered, baseStyles.mb_20, baseStyles.danger_text)}>*All fields are required</p>
      </div>,
      <div className={classnames(baseStyles.form_styles, baseStyles.form_styles__wide)} key='applicant-form-body'>
        <form onSubmit={this._handleSubmit} method="post">
          <h2 className={baseStyles.mb_20}>Personal information</h2>

          <div className={classnames(gridStyles.row, baseStyles.xs_block)}>
            <div className={gridStyles.col_6}>
              <div className={baseStyles.form_field} id="first_name">
                <h4 className={baseStyles.form_label}>First name</h4>
                <Input type="text"
                  value={first_name}
                  name="first_name"
                  placeholder="Enter your first name"
                  block
                  className={classnames(baseStyles.input, { [baseStyles.error]: errors.first_name })}
                  onChange={this.onChange} />
              </div>
            </div>

            <div className={gridStyles.col_6}>
              <div className={baseStyles.form_field} id="last_name">
                <h4 className={baseStyles.form_label}>Surname</h4>
                <Input type="text"
                  value={last_name}
                  name="last_name"
                  placeholder="Enter your surname"
                  block
                  className={classnames(baseStyles.input, { [baseStyles.error]: errors.last_name })}
                  onChange={this.onChange} />
              </div>
            </div>
          </div>

          <h2 className={baseStyles.mb_20}>Educational background</h2>

          <div className={baseStyles.form_field} id="education_level">
            <DropdownForm
              value={education_level}
              onChange={this.onSelect}
              list={educationList}
              field="education_level"
              placeholder="Choose the highest level of education attained"
              className={classnames(baseStyles.input, { [baseStyles.btn_error]: errors.education_level })}
            />
          </div>

          <div className={classnames(gridStyles.row, baseStyles.xs_block)}>
            <div className={gridStyles.col_6}>
              <div className={baseStyles.form_field} id="major">
                <h4 className={baseStyles.form_label}>
                  Major
                  {/* <Tooltip containerClass={baseStyles.tooltip_box} typeIcon="iconQuestion" light small>
                    Choose the subject you feel the most passionate about and would like to complete the majority of tasks in.
                  </Tooltip> */}
                </h4>
                <DropdownForm
                  value={major}
                  onChange={this.onSelect}
                  list={majorList}
                  field="major"
                  placeholder="E.g. Economics, Linguistics etc"
                  className={classnames(baseStyles.input, { [baseStyles.btn_error]: errors.major })}
                  hasSearchValue
                />

                {/* <Input type="text" placeholder="E.g. Economics, Linguistics etc"
                  value={major}
                  name="major"
                  block
                  className={classnames(baseStyles.input, { [baseStyles.error]: errors.major })}
                  onChange={this.onChange} /> */}

              </div>
            </div>

            <div className={gridStyles.col_6}>
              <div className={baseStyles.form_field} id="minor">
                <h4 className={baseStyles.form_label}>
                  Minor
                  {/* <Tooltip containerClass={baseStyles.tooltip_box} typeIcon="iconQuestion" light small>
                    Choose another subject you feel a bit less confident about, but still consider completing tasks in.
                  </Tooltip> */}
                </h4>
                <DropdownForm
                  value={minor}
                  onChange={this.onSelect}
                  list={minorList}
                  field="minor"
                  placeholder="E.g. Philosophy, Art etc"
                  className={classnames(baseStyles.input, { [baseStyles.btn_error]: errors.minor })}
                  hasSearchValue
                />

                {/* <Input type="text" placeholder="E.g. Philosophy, Art etc"
                  value={minor}
                  name="minor"
                  block
                  className={classnames({ [baseStyles.error]: errors.minor })}
                  onChange={this.onChange} /> */}
              </div>
            </div>
          </div>


          <div className={classnames(gridStyles.row, gridStyles.vertical_end)}>
            <div className={gridStyles.col_6}>
              <div className={baseStyles.form_field} id="gpa">
                <h4 className={baseStyles.form_label}>
                  GPA
                  <Tooltip containerClass={baseStyles.tooltip_box} typeIcon="iconQuestion" light small>
                    <b><Link to="/gpa.html" target="_blank">Find here how to calculate your Grade Point Average</Link></b>
                  </Tooltip>
                </h4>
                <DropdownForm
                  value={gpa}
                  onChange={this.onSelect}
                  list={gpaList}
                  field="gpa"
                  placeholder="- Select -"
                  className={classnames({ [baseStyles.btn_error]: errors.gpa })}
                />
              </div>
            </div>

            <div className={gridStyles.col_6}>
              <div className={baseStyles.form_field} id="university">
                <h4 className={baseStyles.form_label}>University</h4>
                <Input type="text"
                  value={university}
                  name="university"
                  block
                  className={classnames(baseStyles.input, { [baseStyles.error]: errors.university })}
                  onChange={this.onChange} />
              </div>
            </div>
          </div>

          <div className={baseStyles.form_field} id="country_university">
            <h4 className={baseStyles.form_label}>Your educational institution is located in (country)</h4>
            <DropdownForm
              value={country_university}
              onChange={this.onSelect}
              list={countryList}
              field="country_university"
              placeholder="Name the country"
              className={classnames({ [baseStyles.btn_error]: errors.country_university })}
              hasSearchValue
            />
            {/* <Input type="text" placeholder="Name the country"
              value={country_university}
              name="country_university"
              block
              className={classnames(baseStyles.input, { [baseStyles.error]: errors.country_university })}
              onChange={this.onChange} /> */}
          </div>

          {/* <div className={baseStyles.form_field} id="subjects">
            <h2 className={baseStyles.mb_20}>Choose up to 5 subjects of your competence:</h2>
            {errors.subjects &&
              <p className={classnames(baseStyles.title_extra_small, baseStyles.danger_text)}>This information is required.</p>
            }
            <div className={baseStyles.form_column_2}>
              {subjectsList.map(s =>
                <Checkbox
                  checked={subjects.indexOf(s) >= 0}
                  onChange={() => this.onSelectSubject(s)}
                  key={`subject_${s}`}
                  disabled={subjects.length >= 5 && subjects.indexOf(s) < 0}
                >
                  {s}
                </Checkbox>
              )}
            </div>
          </div> */}

          <hr className={classnames(baseStyles.mb_20, baseStyles.hr)} />

          <div className={baseStyles.form_field} id="writing_experience">
            <h4 className={baseStyles.form_label}>Do you have any experience in academic writing?</h4>
            <DropdownForm
              value={writing_experience}
              onChange={this.onSelect}
              list={academicExperience}
              field="writing_experience"
              placeholder="- Select -"
              className={classnames({ [baseStyles.btn_error]: errors.writing_experience })}
            />
          </div>

          <hr className={classnames(baseStyles.mb_20, baseStyles.hr)} />

          <div className={baseStyles.form_field} id="online_tutoring_experience">
            <h4 className={baseStyles.form_label}>Any experience in online tutoring?</h4>
            <DropdownForm
              value={online_tutoring_experience}
              onChange={this.onSelect}
              list={tutoringExperience}
              field="online_tutoring_experience"
              placeholder="- Select -"
              className={classnames({ [baseStyles.btn_error]: errors.online_tutoring_experience })}
            />
          </div>

          {showAdditionalField &&

            <div className={gridStyles.row}>
              <div className={gridStyles.col_6}>
                <div className={baseStyles.form_field}>
                  <h4 className={baseStyles.form_label}>Name the platform (optional)</h4>
                  <Input type="text"
                    value={platform_name}
                    name="platform_name"
                    block
                    onChange={this.onChange} />

                </div>
              </div>

              <div className={gridStyles.col_6}>
                <div className={baseStyles.form_field}>
                  <h4 className={baseStyles.form_label}>Add the link to your profile (optional)</h4>
                  <Input type="text"
                    value={link_to_profile}
                    name="link_to_profile"
                    block
                    onChange={this.onChange} />
                </div>
              </div>
            </div>

          }

          <hr className={classnames(baseStyles.mb_20, baseStyles.hr)} />

          <div className={baseStyles.form_field} id="available_hours_per_week">
            <h4 className={baseStyles.form_label}>How many hours per week would you like to work?</h4>
            <DropdownForm
              value={available_hours_per_week}
              onChange={this.onSelect}
              list={hoursList}
              field="available_hours_per_week"
              placeholder="Select the approximate # of hours"
              className={classnames({ [baseStyles.btn_error]: errors.available_hours_per_week })}
            />
            {/* <Input type="text" placeholder="Write the approximate # of hours"
              value={available_hours_per_week}
              name="available_hours_per_week"
              block
              className={classnames(baseStyles.input, { [baseStyles.error]: errors.available_hours_per_week })}
              onChange={this.onChange} /> */}
          </div>

          <hr className={classnames(baseStyles.mb_20, baseStyles.hr)} />

          <div className={baseStyles.form_field} id="preferred_income">
            <h4 className={baseStyles.form_label}>What's your expectation of a monthly income on the platform?</h4>
            <DropdownForm
              value={preferred_income}
              onChange={this.onSelect}
              list={monthlyIncome}
              field="preferred_income"
              placeholder="Select your expected income in USD"
              className={classnames({ [baseStyles.btn_error]: errors.preferred_income })}
              positionBottom
            />
            {/* <Input type="text" placeholder="Write your expected income in USD"
              value={preferred_income}
              name="preferred_income"
              block
              className={classnames(baseStyles.input, { [baseStyles.error]: errors.preferred_income })}
              onChange={this.onChange} /> */}
          </div>

          <div className={baseStyles.form_field}>
            <Button type="button" disabled={isFetching} block onClick={this.onSubmit}>Continue</Button>
          </div>
        </form>

      </div>
    ]
  }
}

const mapStateToProps = state => {
  const profile = state.profile;
  const isFetching = profile && profile.isFetching || false;
  const profileId = get(profile.data, 'user.id');
  const profileVer = get(profile.data, 'user.scenario_version');

  return {
    profileId,
    isFetching,
    profileVer,
  }
};

const mapDispatchToprops = dispatch => ({
  profileUpdateStages: (data) => (dispatch(profileUpdateStages(data))),
  loadProfile: () => {
    dispatch(profileFetchIfNeeded());
  },
});

export default connect(mapStateToProps, mapDispatchToprops)(PageApplicantInfo);



// WEBPACK FOOTER //
// ./src/components/PageApplicantInfo.js